import React, { Fragment, useState, useEffect } from 'react';
import { Breadcrumbs, H6 } from '../../../AbstractElements';
import { Feathericon } from '../../../Constant';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import IconMarkUp from '../Icon-markup';
import axios from 'axios';
import HeaderCard from '../../Common/HeaderCard';
import FeatherIconCom from './FeatherIconCom';

const FeatherIconContainer = () => {
  const [data, setData] = useState([]);
  const [iTag, setiTag] = useState('');
  const [feathericon, setfeatherIcon] = useState('');

  useEffect(() => {
    axios.get(`${process.env.PUBLIC_URL}/api/featherData.json`).then((res) => setData(res.data));
  }, []);

  const getItag = (tag) => {
    setiTag({
      iTag: '<i data-feather="' + tag + '"></i>',
    });
    setfeatherIcon({
      feathericon: tag,
    });
  };

  return (
    <Fragment>
      <Container fluid={true}>
        <Breadcrumbs pageTitle='Feather Icons' parent='Icons' title='Feather Icons' />
        {data.map((icons, index) => {
          return (
            <Row key={index}>
              <Col sm='12'>
                <Card>
                  <HeaderCard title={Feathericon} />
                  <CardBody>
                    <Row className='icon-lists feather-icons'>
                      {icons.feather_icons.map((icon, i) => {
                        return (
                          <Col sm='6 col-12' xl='4' key={i} onClick={(e) => getItag(icon)}>
                            <div className='d-flex'>
                              {icon && <FeatherIconCom iconName={icon} />}
                              <div className='flex-grow-1 align-self-center'>
                                <H6 className='mt-0'>{icon}</H6>
                              </div>
                            </div>
                          </Col>
                        );
                      })}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          );
        })}
      </Container>
      <IconMarkUp itag={iTag} icons={feathericon} />
    </Fragment>
  );
};
export default FeatherIconContainer;
